module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"column":"@:labels.column","operator":"@:labels.operator","value":"@:labels.value","valueHint":"Press \u0027Enter\u0027 or the \u0027plus\u0027 sign to add filter"},"fr":{"column":"@:labels.column","operator":"@:labels.operator","value":"@:labels.value","valueHint":"Appuyez sur \u0027Entrée\u0027 ou sur le signe \u0027plus\u0027 pour ajouter un filtre"}}')
  delete Component.options._Ctor
}
